import { getCookieSuffix } from './getEnvironment';

const COOKIE_BASE_NAME = 'cartwheelPendingSignupFocus';
const COOKIE_MAX_AGE_SECONDS = 60 * 30;

export type PendingSignupInfo = {
  industryFocus: string;
  productFocus: string;
};

function getCookieName() {
  return `${COOKIE_BASE_NAME}${getCookieSuffix()}`;
}

function getCookieDomain() {
  if (typeof window === 'undefined') {
    return '';
  }
  if (window.location.hostname.includes('localhost')) {
    return 'localhost';
  }
  return '.getcartwheel.com';
}

function parsePendingSignupInfo(raw: string): PendingSignupInfo | null {
  try {
    const parsed = JSON.parse(raw) as PendingSignupInfo;
    if (!parsed.industryFocus || !parsed.productFocus) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function stashPendingSignupInfo(focus: PendingSignupInfo) {
  if (typeof document === 'undefined') {
    return;
  }
  if (!focus.industryFocus || !focus.productFocus) {
    return;
  }

  const value = encodeURIComponent(JSON.stringify(focus));
  const domain = getCookieDomain();
  document.cookie = `${getCookieName()}=${value}; domain=${domain}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; secure; samesite=lax`;
}

export function readPendingSignupInfo(): PendingSignupInfo | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const cookieName = getCookieName();
  const cookies = document.cookie.split('; ');
  const entry = cookies.find((cookie) => cookie.startsWith(`${cookieName}=`));
  if (!entry) {
    return null;
  }

  const raw = decodeURIComponent(entry.slice(cookieName.length + 1));
  return parsePendingSignupInfo(raw);
}

export function clearPendingSignupInfo() {
  if (typeof document === 'undefined') {
    return;
  }

  const domain = getCookieDomain();
  document.cookie = `${getCookieName()}=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
}
